// extracted by mini-css-extract-plugin
export default {"noRecordingBanner":"noRecordingBanner__xLdImu","noRecordingBannerIcon":"noRecordingBannerIcon__wQF4Yz","noRecordingBannerText":"noRecordingBannerText__IcJl1P"};